import type { Dimensions } from '../core';

/**
 * Calls `onSize` with the element's size now and whenever it changes. Falls back to a single read where
 * ResizeObserver is missing (jsdom). Returns the cleanup function.
 */
export const observeSize = (element: HTMLElement, onSize: (size: Dimensions) => void): (() => void) => {
  const report = () => {
    const { width, height } = element.getBoundingClientRect();
    onSize({ width, height });
  };
  report();
  if (typeof ResizeObserver === 'undefined') return () => undefined;
  const observer = new ResizeObserver(report);
  observer.observe(element);
  return () => observer.disconnect();
};
